import React from 'react';
import './LandingPage.css';

const invitationSteps = [
  {
    number: '01',
    title: 'Begin with a thought',
    copy: 'A question, a possibility, or something you cannot quite articulate yet.',
  },
  {
    number: '02',
    title: 'Bring someone in',
    copy: 'Invite another perspective to explore, discuss, and reshape the idea.',
  },
  {
    number: '03',
    title: 'See what connects',
    copy: 'Follow the branches together and discover what neither of you expected.',
  },
];

function LandingPage({ onSignInClick }) {
  return (
    <main className="landing" aria-labelledby="landing-title">
      <div className="landing__ambient" aria-hidden="true" />
      <section className="landing__hero">
        <div className="landing__copy">
          <p className="landing__eyebrow">A shared space for ideas in motion</p>
          <h1 id="landing-title">Some ideas belong together</h1>
          <p className="landing__lead">
            Mindmappi brings thoughts, people and possibilities into the same
            space.
          </p>
          <p className="landing__support">
            Share a half-formed idea. Discover unexpected connections. Discuss
            it, reshape it and let it become something no one could have made
            alone.
          </p>
          <button
            type="button"
            className="landing__primary-action"
            onClick={onSignInClick}
          >
            Sign in / Sign up
            <span aria-hidden="true">↗</span>
          </button>

          <div className="landing__invitation" aria-label="How Mindmappi works">
            {invitationSteps.map((step) => (
              <article className="landing__invitation-step" key={step.number}>
                <span className="landing__step-number" aria-hidden="true">
                  {step.number}
                </span>
                <div>
                  <h2>{step.title}</h2>
                  <p>{step.copy}</p>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="landing__visual-column">
          <section className="landing-video" aria-labelledby="landing-video-title">
            <div className="landing-video__content">
              <span className="landing-video__label">A glimpse of Mindmappi</span>
              <div className="landing-video__play" aria-hidden="true">
                <span />
              </div>
              <h2 id="landing-video-title">A short story will live here</h2>
              <p>
                A future video will show an unfinished thought becoming a
                shared map, one perspective at a time.
              </p>
              <span className="landing-video__status">Video coming soon</span>
            </div>
          </section>
          <p className="landing__closing">Good ideas need chemistry.</p>
        </div>
      </section>
      <footer className="landing__legal">
        <a href="/terms">Terms</a>
        <a href="/privacy">Privacy</a>
        <a href="mailto:info@mindmappi.com">Contact</a>
      </footer>
    </main>
  );
}

export default LandingPage;
